<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Zhangjiagang Electronics Plant
                </div>
                <div class="manufacture-t2">
                    Located in Zhangjiagang, Jiangsu Province, covering an area of 22,000 ㎡.<br />
                    The factory is equipped with SMT, DIP, assembly and testing production lines.
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                PCBA - SMT
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Highly Automated and Intelligent
                            </div>
                            <div class="destils">
                                - Automated Production: Full-process automation from PCB loading to finished goods, using automatic chip mounters, printers and reflow ovens.<br />
                                - Intelligent Control: Real-time monitoring and process optimization via MES & IoT.<br />
                                - AI & Machine Learning: AI-driven defect detection, predictive maintenance and process optimization.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                High Precision & High Mounting Speed
                            </div>
                            <div class="destils">
                                - Placement Accuracy: Advanced mounters (Siemens SX series) achieve ±25μm accuracy, supporting 01005 and smaller components.<br />
                                - High Speed: Multi-gantry mounters exceed 200,000 CPH. Dual-track lines double efficiency.<br />
                                - Fine-Pitch Capability: Supports QFN, BGA, CSP for high-density PCBs in 5G and automotive electronics.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Flexibility & Quick Changeover
                            </div>
                            <div class="destils">
                                - Quick Changeover: Intelligent programming & modular design reduce changeover time within 10 mins, ideal for multi-variety, small-batch production.<br />
                                - Compatibility: Supports PCBs from 50×50mm to 510×460mm for LED, consumer electronics & medical applications.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Reliability Enhancement Technology
                            </div>
                            <div class="destils">
                                - In-line Inspection: AOI, AXI & flying probe testing ensure real-time defect rejection, with FPY over 99%.<br />
                                - Environment Control: Constant temperature & humidity, ESD protection safeguard precision components.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                PCBA - DIP
            </div>
            
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Soldering Line
                            </div>
                            <div class="destils">
                                Selective soldering: Local soldering for THT & SMT+THT PCBs, avoiding thermal shock to sensitive components.<br />
                                - High precision: Multi-nozzle design, 2 mm minimum pitch, ±50 μm accuracy via laser/visual positioning.<br />
                                - Intelligent & reliable: Independent temperature control (up to 300℃), nitrogen atmosphere for 20%+ better wettability.<br />
                                - Flexible production: Changeover＜5 min, supports 50×50 to 500×450 mm PCBs and odd-shaped components.<br />
                                - In-line traceability: Integrated AOI/3D inspection, MES-based full-process parameter recording.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Pin Insertion Line
                            </div>
                            <div class="destils">
                                Pin insertion for THT components: pin headers, terminals, relays, etc.<br />
                                - High Precision & Speed: Servo + vision positioning, ±0.05mm accuracy, 0.5mm pitch, >10,000 pins/hour.<br />
                                - Smart Error Prevention: Force feedback avoids bending/missing pins, defect rate ＜0.1%. AI optimizes insertion sequence.<br />
                                - Flexible & Quick Change: Modular fixtures, changeover ＜3 mins. Supports THT and Press-fit.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Coating Line
                            </div>
                            <div class="destils">
                                Conformal coating for PCBs to enhance moisture, corrosion and dust resistance.<br />
                                - High Precision Selective Spraying: Non-contact spraying, 10-50μm (±5μm) thickness, vision positioning to avoid no-spray areas.<br />
                                - Smart Process Control: Auto-adjust pressure/flow for various coatings. UV/hot air curing ＜30s.<br />
                                - Environmental & Safe: Closed spraying + VOC treatment, RoHS/REACH compliant. Coating utilization >90%.<br />
                                - In-line Inspection & Traceability: IR/3D inspection, MES records parameters for quality traceability.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                Highly Automated Assembly
            </div>
            <div class="page-t2">
                Complete machine assembly involves processes such as structural part assembly, screw locking, gluing, wire harness connection and shell packaging.
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Robotic Assembly
                            </div>
                            <div class="destils">
                                Collaborative robots / 6-axis arms for precision assembly.
                                
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Automatic Screw Locking
                            </div>
                            <div class="destils">
                                Servo + vision, torque accuracy ±1%, prevents missing/loose screws.
                                
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                Auto Dispensing & Bonding
                            </div>
                            <div class="destils">
                                High-precision jet dispensing with ±0.02mm tolerance.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-3.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                Final Product - Testing
            </div>
            <div class="page-t2">
                The testing process includes fully automated testing, intelligent data analysis, a high-compatibility test system, radio frequency calibration, etc.
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Fully Automated Testing
                            </div>
                            <div class="destils">
                                - Robot Automatic Loading & Unloading: Robotic arms (e.g., EPSON SCARA robots) feed products to be tested into test stations, minimizing manual intervention.<br />
                                - Parallel Testing: Multi-station simultaneous testing (e.g., 4 mobile phones undergoing 5G RF calibration at the same time), improving efficiency by 300%.<br />
                                - AI Visual Inspection: Deep learning algorithms identify appearance defects (scratches, color differences) with an accuracy of >99.9% (e.g., Cognex ViDi).
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Intelligent Data Analysis
                            </div>
                            <div class="destils">
                                - Real-time monitoring and early warning: SPC (Statistical Process Control) analyzes test data and automatically triggers alarms (e.g., out-of-tolerance parameters).<br />
                                - Predictive maintenance: Predict test equipment failures through data such as vibration and temperature to reduce downtime.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Highly Compatible Test System
                            </div>
                            <div class="destils">
                                - Modular test architecture: Supports quick change of test fixtures (e.g., shared test platform for mobile phones, TWS earbuds and smart watches).<br />
                                - OTA (Over-the-Air) test: Automated RF testing for 5G / Wi-Fi 6E / Bluetooth (e.g., Keysight UXM5G tester).
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Zhangjiagang Electronics Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/el/zhangjiagang.html'
};

import { createApp } from 'vue';
import App from './zhangjiagang.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./zhangjiagang.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
